import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import Button from "../shared/button";
import { Drawer } from "antd";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const [topPosition, setTopPosition] = useState("-2%");
  const [open, setOpen] = useState(false);
  const [placement, setPlacement] = useState("left");
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleScroll = () => {
    const currentScrollPos = window.scrollY + 100;
    if (currentScrollPos > 50) {
      setTopPosition("-4%");
    } else {
      setTopPosition("-2%");
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <nav className="max-md:hidden bg-white rounded-[25px] max-xxxl:w-[90%] w-[80%] p-[20px] m-auto  absolute  shadow-md left-1/2 transform -translate-x-1/2 backdrop-blur-lg top-[3%] z-[4]">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <NavLink to="/">
              <img
                src="../../logo.png"
                alt="Logo"
                className="w-[55px] h-[45px]"
              />
            </NavLink>
          </div>

          <ul className="md:flex space-x-9 max-xxl:space-x-5">
            <li className="uppercase small text-[#333333] font-bold leading-[21px] font-manrope">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `cursor-pointer px-2 py-1 rounded-[45px] ${
                    isActive ? "bg-[#333] text-white px-[22px] py-[10px]" : ""
                  }`
                }
              >
                {t("navbar.home")}
              </NavLink>
            </li>

            <li className="uppercase small text-[#333333] font-bold leading-[21px] font-manrope">
              <NavLink
                to="/about-us"
                className={({ isActive }) =>
                  `cursor-pointer px-2 py-1 rounded-[45px] ${
                    isActive ? "bg-[#333] text-white px-[22px] py-[10px]" : ""
                  }`
                }
              >
                {t("navbar.about")}
              </NavLink>
            </li>

            <li className="uppercase small text-[#333333] font-bold leading-[21px] font-manrope">
              <NavLink
                to="/features"
                className={({ isActive }) =>
                  `cursor-pointer px-2 py-1 rounded-[45px] ${
                    isActive ? "bg-[#333] text-white px-[22px] py-[10px]" : ""
                  }`
                }
              >
                {t("navbar.features")}
              </NavLink>
            </li>

            <li className="uppercase small text-[#333333] font-bold leading-[21px] font-manrope">
              <NavLink
                to="/pricing"
                className={({ isActive }) =>
                  `cursor-pointer px-2 py-1 rounded-[45px] ${
                    isActive ? "bg-[#333] text-white px-[22px] py-[10px]" : ""
                  }`
                }
              >
                {t("navbar.pricing")}
              </NavLink>
            </li>

            <li className="uppercase small text-[#333333] font-bold leading-[21px] font-manrope">
              <NavLink
                to="/blogs"
                className={({ isActive }) =>
                  `cursor-pointer px-2 py-1 rounded-[45px] ${
                    isActive || location.pathname === "/blog-detail"
                      ? "bg-[#333] text-white px-[22px] py-[10px]"
                      : ""
                  }`
                }
              >
                {t("navbar.blog")}
              </NavLink>
            </li>
          </ul>

          <div className="button">
            <Button
              text={t("navbar.button")}
              className="button btn-secondary"
              height={60}
              width={198}
              onClick={() => {
                navigate("/login");
              }}
            ></Button>
          </div>
        </div>
      </nav>

      <div className="mobile-navbar hidden max-md:flex justify-between items-center p-[20px]">
        <NavLink to="/">
          <img src="../../logo.png" alt="Logo" className="w-[60px] h-[40px]" />
        </NavLink>

        <Icon
          icon="pajamas:hamburger"
          style={{ color: "black" }}
          onClick={() => setOpen(!open)}
          width={30}
        />

        <Drawer
          placement={placement}
          closable={false}
          onClose={onClose}
          open={open}
          key={placement}
          width="80%"
        >
          <div className="flex justify-between items-center">
            <NavLink to="/">
              <img
                src="../../logo.png"
                alt="Logo"
                className="w-[55px] h-[45px] my-[10px] mx-[20px]"
              />
            </NavLink>
            <Icon
              color="black"
              icon="charm:cross"
              width={24}
              height={24}
              onClick={() => {
                setOpen(false);
              }}
            />
          </div>

          <ul className="flex flex-col space-y-5 p-[20px]">
            <li className="uppercase small text-[#333333] font-bold leading-[21px] font-manrope">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `cursor-pointer px-2 py-1 rounded-[45px] ${
                    isActive ? "bg-[#333] text-white px-[22px] py-[10px]" : ""
                  }`
                }
                onClick={() => {
                  setOpen(false);
                }}
              >
                Home
              </NavLink>
            </li>

            <li className="uppercase small text-[#333333] font-bold leading-[21px] font-manrope">
              <NavLink
                to="/about-us"
                className={({ isActive }) =>
                  `cursor-pointer px-2 py-1 rounded-[45px] ${
                    isActive ? "bg-[#333] text-white px-[22px] py-[10px]" : ""
                  }`
                }
                onClick={() => {
                  setOpen(false);
                }}
              >
                About us
              </NavLink>
            </li>

            <li className="uppercase small text-[#333333] font-bold leading-[21px] font-manrope">
              <NavLink
                to="/features"
                className={({ isActive }) =>
                  `cursor-pointer px-2 py-1 rounded-[45px] ${
                    isActive ? "bg-[#333] text-white px-[22px] py-[10px]" : ""
                  }`
                }
                onClick={() => {
                  setOpen(false);
                }}
              >
                Features
              </NavLink>
            </li>

            <li className="uppercase small text-[#333333] font-bold leading-[21px] font-manrope">
              <NavLink
                to="/pricing"
                className={({ isActive }) =>
                  `cursor-pointer px-2 py-1 rounded-[45px] ${
                    isActive ? "bg-[#333] text-white px-[22px] py-[10px]" : ""
                  }`
                }
                onClick={() => {
                  setOpen(false);
                }}
              >
                Pricing
              </NavLink>
            </li>

            <li className="uppercase small text-[#333333] font-bold leading-[21px] font-manrope">
              <NavLink
                to="/blogs"
                className={({ isActive }) =>
                  `cursor-pointer px-2 py-1 rounded-[45px] ${
                    isActive || location.pathname === "/blog-detail"
                      ? "bg-[#333] text-white px-[22px] py-[10px]"
                      : ""
                  }`
                }
                onClick={() => {
                  setOpen(false);
                }}
              >
                Blog
              </NavLink>
            </li>
          </ul>

          <div className="button">
            <Button
              text="Get Started"
              className="button btn-secondary"
              height={40}
              width={148}
              onClick={() => {
                navigate("/login");
              }}
            ></Button>
          </div>
        </Drawer>
      </div>
    </>
  );
};

export default Navbar;
